module.exports = __webpack_public_path__ + "269274763eff686d3c27aece90a0c026.png";